import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Link, Alert } from '@grandvisionhq/common';
import { StoreTile, StoreTileSection, StoreTileImage, StoreTileText, StoreTileHeading, Address, StoreTileTags, StoreTileIcons, OpeningHours } from '@grandvisionhq/locations';
import { Sizes, Colors } from '../StoreRating/StoreRating/Star.js';
import { Stars } from '../StoreRating/StoreRating/Stars.js';

const StoreFinderItem = (_param)=>{
    var { addressSize , buttons , className , distance , labels , onExpandOpeningHoursCallback , onClickStoreDetailsLinkCallback , onClickStoreDetailsTitleCallback , store , showEmailAddress , showPhone , showOpeningHours =true , showAttributesAs , storeDetailsUrl , view ='list' , variant ='default' , availability  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "addressSize",
        "buttons",
        "className",
        "distance",
        "labels",
        "onExpandOpeningHoursCallback",
        "onClickStoreDetailsLinkCallback",
        "onClickStoreDetailsTitleCallback",
        "store",
        "showEmailAddress",
        "showPhone",
        "showOpeningHours",
        "showAttributesAs",
        "storeDetailsUrl",
        "view",
        "variant",
        "availability"
    ]);
    const { code , shortName , emailAddress , phone , storeDetailImage , openingHours , specialOpeningHours , storeNote , rating , wheelchairAccessible , hearingAppointmentPossible , isFranchiseStore ,  } = store;
    const canShowEmailAddress = showEmailAddress && emailAddress;
    const canShowPhone = showPhone && phone;
    const canShowRating = typeof (rating === null || rating === void 0 ? void 0 : rating.value) === 'number';
    const canShowUrl = storeDetailsUrl === null || storeDetailsUrl === void 0 ? void 0 : storeDetailsUrl.length;
    const attributes = {
        hearingAppointmentPossible: !!hearingAppointmentPossible,
        wheelchairAccessible: !!wheelchairAccessible,
        isFranchiseStore: !!isFranchiseStore
    };
    const canShowAttributes = showAttributesAs && (wheelchairAccessible || hearingAppointmentPossible || isFranchiseStore);
    return /*#__PURE__*/ React.createElement(StoreTile, swcHelpers.extends({
        id: code.toString(),
        className: classnames('store-finder__item', `store-finder__item--${view}`, className),
        variant: variant ? variant : 'default'
    }, rest), view === 'map' && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
              .gm-style .gm-style-iw-c {
                border-radius: 6px;
                border: 1px solid white;
              }

              .gm-style .gm-style-iw-c:has(.stores-v2-store-finder-item:enabled):hover {
                border: 1px solid var(--color--button-outline-hover);
              }

              .gm-style .gm-style-iw-tc {
                display: none !important;
              }

              .gm-style .gm-style-iw-c .gm-ui-hover-effect {
                display: none !important;
              }
            `)), /*#__PURE__*/ React.createElement("header", null, storeDetailImage ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(StoreTileImage, {
        url: storeDetailImage
    })) : null, /*#__PURE__*/ React.createElement(StoreTileSection, {
        asideSlot: distance ? /*#__PURE__*/ React.createElement(StoreTileText, {
            color: "text-secondary",
            variant: "caption",
            className: "store-finder__distance"
        }, distance) : null
    }, /*#__PURE__*/ React.createElement(StoreTileHeading, {
        variant: "subheading1",
        component: "h3"
    }, canShowUrl ? /*#__PURE__*/ React.createElement(Link, {
        href: storeDetailsUrl,
        className: "store-finder__heading-link",
        onClick: onClickStoreDetailsTitleCallback
    }, shortName) : shortName))), /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(StoreTileText, {
        variant: "caption",
        component: "div",
        color: "text-secondary"
    }, /*#__PURE__*/ React.createElement(Address, {
        size: addressSize,
        data: {
            streetName: store.streetName,
            streetNumber: store.streetNumber,
            additionalStreetInfo: store.additionalStreetInfo,
            postalCode: store.postalCode,
            town: store.town,
            province: store.province
        },
        className: "store-finder__address--item"
    }))), canShowAttributes && /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, showAttributesAs === 'tags' && /*#__PURE__*/ React.createElement(StoreTileTags, {
        tags: attributes
    }), showAttributesAs === 'icons' && /*#__PURE__*/ React.createElement(StoreTileIcons, {
        icons: attributes
    })), canShowRating ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, /*#__PURE__*/ React.createElement(Stars, {
        size: Sizes.small,
        color: Colors.black,
        className: "store-rating__stars",
        rating: rating.value,
        "aria-hidden": true
    })) : null, canShowEmailAddress || canShowPhone || storeDetailsUrl ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: "medium"
    }, canShowPhone && /*#__PURE__*/ React.createElement(StoreTileText, {
        variant: "caption-head",
        component: "div",
        color: "primary"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: `tel:${phone.replace(/\s/g, '')}`,
        iconBefore: "phone",
        iconSize: {
            width: 20,
            height: 20
        }
    }, phone)), canShowEmailAddress && /*#__PURE__*/ React.createElement(StoreTileText, {
        variant: "caption-head",
        component: "div",
        color: "primary"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: `mailto:${emailAddress}`,
        iconBefore: "mail",
        iconSize: {
            width: 20,
            height: 20
        }
    }, emailAddress)), storeDetailsUrl && /*#__PURE__*/ React.createElement(StoreTileText, {
        variant: "caption-head",
        component: "div",
        color: "primary"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: storeDetailsUrl,
        iconBefore: "store",
        iconSize: {
            width: 20,
            height: 20
        },
        onClick: onClickStoreDetailsLinkCallback
    }, labels === null || labels === void 0 ? void 0 : labels.storeDetailsLink))) : null, showOpeningHours ? /*#__PURE__*/ React.createElement(StoreTileSection, {
        marginBottom: !storeNote ? 'medium' : undefined
    }, /*#__PURE__*/ React.createElement(StoreTileText, {
        variant: "body",
        component: "div"
    }, /*#__PURE__*/ React.createElement(OpeningHours, {
        isExpandable: view === 'list' ? true : false,
        onExpandCallback: view === 'list' ? onExpandOpeningHoursCallback : undefined,
        openingHours: openingHours,
        specialOpeningHours: specialOpeningHours
    }))) : null, availability ? /*#__PURE__*/ React.createElement(StoreTileText, {
        variant: "caption-head",
        component: "div"
    }, availability) : null, storeNote ? /*#__PURE__*/ React.createElement(StoreTileSection, null, /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        message: /*#__PURE__*/ React.createElement(StoreTileText, {
            variant: "caption"
        }, storeNote),
        className: "store-finder__alert--item"
    })) : null, buttons ? /*#__PURE__*/ React.createElement("footer", {
        className: "store-finder__item-footer"
    }, buttons) : null);
};
var StoreFinderItem$1 = StoreFinderItem;

export { StoreFinderItem$1 as default };
//# sourceMappingURL=StoreFinderItem.js.map
